export default __webpack_public_path__ + "static/media/pricing_icon2.c3093d99.png";